import { Endpoint } from '../endpoint';

export const ReferenceList = new Endpoint('reference_list');
